<!--
 * @Description: 物流监控/订单信息 表格详情
 * @Author: l_hc
 * @LastEditors: Do not edit
 * @Date: 2019-06-19 15:26:14
 * @LastEditTime: 2019-08-10 16:24:57
 -->
<template>
  <transition name="fade">
    <div class="table-body-item-content">
      <div class="table-body-item-content-item">
        <el-row class="marginbottom27">
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">订单编号：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.orderNum }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">订单状态：</el-col>
              <el-col :span="18" style="text-align: left;" :style="{color: orderStatus}">{{ tableData.orderStatusLabel }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">交易日期：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.createDate }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6" />
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">起运地：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.startPlace }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">目的地：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.stopPlace }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">货物名称：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.goodsTypeLabel }}#{{ tableData.goodsName }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">货物重量：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.weight }}吨</el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div class="table-body-item-content-item">
        <el-row>
          <el-col class="marginbottom27 title" :span="6">
            货源方信息
          </el-col>
        </el-row>
        <el-row class="center">
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">单位名称：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.goodsCompany }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">货物名称：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.goodsTypeLabel }}{{ tableData.goodsName }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">联系电话：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.goodsTel }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6" />
        </el-row>
      </div>
      <div class="table-body-item-content-item">
        <el-row>
          <el-col class="marginbottom27 title" :span="6">
            承运方信息
          </el-col>
        </el-row>
        <el-row class="center">
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">单位名称：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.transportCompany }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">联系人：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.transportPerson }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">联系电话：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.transportTel }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6" />
        </el-row>
      </div>
      <div class="table-body-item-content-item">
        <el-row>
          <el-col class="marginbottom27 title" :span="22">
            运单详情
          </el-col>
          <el-col :span="2" style="text-align: right;">
            <el-button plain class="details" size="small" @click="tableitem = !tableitem">
              详情
              <i :class="{expand: tableitem}" class="el-icon-d-arrow-right" />
            </el-button>
          </el-col>
        </el-row>
        <el-row class="center">
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">起运日期：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.startSportDate }}</el-col>
            </el-row>
          </el-col>
          <el-col :span="6">
            <el-row>
              <el-col :span="6" style="text-align: right;">到达日期：</el-col>
              <el-col :span="18" style="text-align: left;">{{ tableData.stopSportDate }}</el-col>
            </el-row>
          </el-col>
          <!--<el-col :span="6">-->
          <!--<el-row>-->
          <!--<el-col :span="6" style="text-align: right;">运输距离：</el-col>-->
          <!--<el-col :span="18" style="text-align: left;">{{ tableData.transportKm }}</el-col>-->
          <!--</el-row>-->
          <!--</el-col>-->
          <el-col :span="6" />
        </el-row>
        <transition name="fade">
          <div v-if="tableitem" class="waybill-box">
            <div v-if="tableData.managerTransportOrders.length <= 0" class="no-data-info">
              <font>暂无匹配数据</font>
            </div>
            <div v-for="(item, index) in tableData.managerTransportOrders" :key="index" class="waybill-box-item">
              <el-row>
                <el-col class="marginbottom27 title" :span="6">
                  运单{{ index+1 }}：{{ item.transportType }}
                </el-col>
              </el-row>
              <el-row class="center marginbottom27">
                <el-col :span="6">
                  <el-row>
                    <el-col :span="8" style="text-align: right;">起运地：</el-col>
                    <el-col :span="16" style="text-align: left;">{{ item.startPlace }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row>
                    <el-col :span="8" style="text-align: right;">目的地：</el-col>
                    <el-col :span="16" style="text-align: left;">{{ item.stopPlace }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row>
                    <el-col :span="8" style="text-align: right;">承运单位：</el-col>
                    <el-col :span="16" style="text-align: left;">{{ tableData.transportCompany }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row>
                    <el-col :span="8" style="text-align: right;">货物重量：</el-col>
                    <el-col :span="16" style="text-align: left;">{{ item.weight }}吨</el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row class="center">
                <el-col :span="6">
                  <el-row>
                    <el-col :span="8" style="text-align: right;">联系人：</el-col>
                    <el-col :span="16" style="text-align: left;">{{ item.transportPerson }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row>
                    <el-col :span="8" style="text-align: right;">联系电话：</el-col>
                    <el-col :span="16" style="text-align: left;">{{ item.transportTel }}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="6" />
                <el-col :span="6" />
              </el-row>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'TableItem',
  props: {
    tableData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      tableitem: false
    }
  },
  computed: {
    // 订单状态字体颜色
    orderStatus() {
      const obj = {
        '运输中': '#148B00',
        '待运输': ''
      }
      return obj[this.tableData.orderStatus]
    }
  },
  created() {
    console.log(this.tableData)
  }
}
</script>

<style lang="scss" scoped>
.center{
  text-align: center;
}
// 详情按钮颜色
  /deep/.el-button.is-plain:focus, .el-button.is-plain:hover{
    color: $base-color;
    border-color: $base-color;
  }
.details{
    font-size: 14px;
    border-color: $base-color;
    color: $base-color;
    span > i {
        transition: 1s all;
        transform: rotateZ(90deg);
        &.expand {
        transform: rotateZ(-90deg);
        }
    }
}

.table-body-item-content{
  background-color: #fafbff;
  &-item{
    font-size: 14px;
    padding: 15px 26px;
    border-top: 1px solid rgba(218,218,218,1);
    .marginbottom27{
      margin-bottom: 27px;
    }
    .title{
      font-size: 16px;
      color: $base-color;
      font-weight: bold;
    }
    .waybill-box-item{
      border: 1px solid #9AB2FF;
      padding: 19px 14px;
      margin-top: 25px;
      .title{
        font-weight:400;
        color: #000;
      }
    }
  }
}
// 显示隐藏动画
.fade-enter-active, .fade-leave-active {
  transition: all 1s;
}
.fade-enter{
  opacity: 0;
}
.fade-leave-to{
  height: 0;
  overflow: hidden;
}
</style>
